import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'users',
    component: () => import('../views/pages/Top/List.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/pages/Login/Login.vue'),
    meta: {notAuth: true, layout: 'login'}
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: () => import('../views/pages/User/New.vue'),
  },
  {
    path: '/users/edit/:id',
    name: 'users.edit',
    component: () => import('../views/pages/User/Edit.vue'),
  },
  {
    path: '/setting/agreement',
    name: 'setting.agreement',
    component: () => import('../views/pages/Setting/Agreement/List.vue'),
    props: route => {
      const page = route.query.page
      return {page: /^[1-9][0-9]*$/.test(page) ? parseInt(page) : 1}
    }
  },
  {
    path: '/setting/agreement/:id',
    name: 'setting.agreement.edit',
    component: () => import('../views/pages/Setting/Agreement/Edit.vue'),
    props: true
  },

  // not found
  {path: '*', component: () => import('../views/pages/Top/List.vue')},

]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  base: process.env.BASE_URL,
  routes
})

// ログインしていなかったらログインページにリダイレクト
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.notAuth)) {
    next();
  } else {
    if (store.getters['auth/check'] === false) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      });
    } else {
      next();
    }
  }
});

export default router
